define('rebrush/components/category/layered',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'bootstrap-collapse'
], function(
	$,
	_,
	Component,
	BEM
) {
	return Component.create({
		block:			null,
		categoryBlock:	null,
		filterTitles:	null,
		filterPanels:	null,
		state:			null,

		$init: function() {
			this.state = JSON.parse(Mage.Cookies.get('gigaset_filter_state') || '{}');
			this.block = BEM.block('layered-nav');
			this.categoryBlock = BEM.block('layer-category-tree');
			this.filterTitles = this.block.getElements('filter-title');
			this.filterPanels = this.block.getElements('filter-panel');

			this._initializeEvents();
			this._initializeActiveStatus();
			this.restoreState();
		},

		_initializeEvents: function() {
			var self = this;

			this.block.on('hide.bs.collapse show.bs.collapse', function(e) {
				var collapsible = $(e.target),
					panel = collapsible.parents(this.filterPanels).first(),
					attributeId = panel.data('attribute-id');

				if (attributeId) {
					self.state[attributeId] = (e.type === 'show');
					self.persistState();
				}
			});

			this.block.on('click', '.' + BEM.buildElementClassname('layer-category-tree', 'item-opener'), function(e) {
				e.preventDefault();
			});
		},

		_initializeActiveStatus: function() {
			var path = _.get(window, 'gigaset.category.current');
			_.forEach(path, _.bind(function(categoryId) {
				var item = this.categoryBlock.find('[data-node-id="category-node-' + categoryId + '"]');

				item.bemAddModifier('active');
				item.find('[data-toggle="collapse"]').removeClass('collapsed');
				item.find('.collapse').addClass('in');
			}, this));
		},

		restoreState: function() {
			_.forEach(this.state, _.bind(function(value, key) {
				var query = '[data-attribute-id="' + key + '"]';

				this.filterTitles.filter(query).find('[data-toggle="collapse"]')[value ? 'removeClass' : 'addClass']('collapsed');
				this.filterPanels.filter(query).find('.collapse')[value ? 'addClass' : 'removeClass']('in');
			}, this));
		},

		persistState: function() {
			Mage.Cookies.set('gigaset_filter_state', JSON.stringify(this.state));
		}
	});
});
